import { css, theme } from '@fable/theme'
import {
  HomeFeaturesHeader,
  HomeFeaturesIllo,
  PopularClubsCarousel,
} from '../../components'
import { HomeFeaturesProps } from '../types'
import { getCmsAsset } from '@fable/utils'
import { routes } from 'app/marketing/routes'

const discuss: HomeFeaturesProps = {
  id: 'discuss',
  header: (
    <HomeFeaturesHeader
      label="Discuss"
      title="Community for story lovers"
      description="Join clubs or share posts to rabbit hole with fellow book and TV fans."
      link={{
        link: routes.clubsPage,
        text: 'Explore clubs',
      }}
    />
  ),
  illo: (
    <HomeFeaturesIllo
      className={css`
        z-index: 2;
        margin-top: 20px;
        margin-bottom: -62%;
        width: 120%;
        right: -4%;
        position: relative;
        ${theme.mediaQueries.mobileL} {
          transform: scale(-1, 1);
          margin-bottom: -36%;
          width: 70%;
          right: -12%;
          left: auto;
        }
        ${theme.mediaQueries.tablet} {
          transform: scale(1);
          margin-bottom: -45.5%;
          left: -15%;
          align-self: flex-start;
          width: 88%;
          object-fit: contain;
          object-position: bottom;
        }
        ${theme.mediaQueries.desktopL} {
          max-width: 523px;
        }
      `}
      image={getCmsAsset(
        '3smdwTwU6DHhTo9tyOAElT/b5ac8699890d874a7fd32efe82af0cff/person-sitting-looking-at-phone.png',
        { width: 1600 }
      )}
      altText="person sitting looking at phone"
    />
  ),
  scrollingCards: [
    {
      title: 'Dedicated Book and tv feed',
      image: getCmsAsset(
        '6FNkCm6R9YIh9oTgIroLSg/862a1691f83548912cedf17b13f64d93/cameron-capello-anime-post.webp'
      ),
      altText: 'fable anime post by cameron capello',
    },
    {
      title: 'Message all your friends',
      image: getCmsAsset(
        '4RsOpbNfAe71QbIUzTpkoE/366548c14d25fa38d9ac375ddccfff8c/group-chat-preview-featured.webp'
      ),
      altText: 'group chat preview preview',
    },
  ],
  slides: {
    mobile: [
      {
        title: 'Spoiler-free discussion rooms',
        image: getCmsAsset(
          '20C87rKxm5rHInmJn7xUsT/71513b8b434beede3319c9ec9755ac2d/friends-messages-preview-mobile.webp'
        ),
        altText: 'discussion rooms',
        titleStyles: css`
          max-width: 200px;
          ${theme.mediaQueries.mobileL} {
            max-width: 310px;
          }
        `,
      },
      {
        title: 'Dedicated book and tv feeds',
        image: getCmsAsset(
          '3dgfOG5Po0CI1JViTaItoz/0a2dffa186ee81d01e5025477a73c394/cameron-capello-anime-post-mobile.webp'
        ),
        altText: 'fable anime post by cameron capello',
      },
      {
        title: 'Message all your friends',
        image: getCmsAsset(
          '65z6vGHjEY5Nau04Vr9L4a/d5d0e20ff2dc4b70608bcdfc82f3f01a/group-chat-preview-mobile.webp'
        ),
        altText: 'group chat preview',
      },
    ],
    desktop: {
      title: 'Tools for clubs to stay organized',
      images: [
        {
          image: getCmsAsset(
            'D7yIse4rEIkPPNmcBygfi/a1b7ecce7a6216a5e24891cce999b534/friends-messages-preview.webp',
            { width: 1800 }
          ),
          altText: 'discussion rooms preview',
        },
        {
          image: getCmsAsset(
            '4fTwXitXtD9bjQQ0YYMQUh/f9fdcf2c2073fe282ea94a3cb1677caa/user-polls-preview.webp',
            { width: 1800 }
          ),
          altText: 'user polls preview',
        },
        {
          image: getCmsAsset(
            '1DufXSd1fx1QwjXPnNv4zk/67ebc6d84040b0e08fca46e066d746f6/group-chat-preview.webp',
            { width: 1800 }
          ),
          altText: 'group chat preview',
        },
      ],
    },
  },
  footer: <PopularClubsCarousel />,
}

const discover: HomeFeaturesProps = {
  id: 'discover',
  reverse: true,
  header: (
    <HomeFeaturesHeader
      label="Discover"
      title="What to read and watch next"
      description="Explore friends’ lists and take fun mood quizzes to find just what you want."
    />
  ),
  illo: (
    <HomeFeaturesIllo
      className={css`
        margin-bottom: -48px;
        ${theme.mediaQueries.mobileS} {
          margin-bottom: -58px;
        }
        ${theme.mediaQueries.mobileL} {
          margin-bottom: -48px;
        }
        ${theme.mediaQueries.tablet} {
          margin-bottom: -68px;
        }
      `}
      image={getCmsAsset(
        'iIzmkPWubiIM7T0cSU5mR/a32dc86d95c3a39dbdced0ce4a4036f2/person-with-bird-and-stars.png',
        { width: 1600 }
      )}
      altText="person sitting with bird and stars"
    />
  ),
  scrollingCards: [
    {
      containerStyles: css`
        overflow: visible;
      `,
      titleStyles: css`
        max-width: 140px;
      `,
      title: 'Take a mood quiz',
      image: getCmsAsset(
        '2xR5MvjCbBqTTxNlaqHtIH/4ca5fc60ba3b9caec3bb8e3f4f9b5781/mood-quiz-preview.webp'
      ),
      imageStyles: css`
        transform: scale(1.25);
      `,
      altText: 'mood quiz preview',
    },
    {
      titleStyles: css`
        max-width: 160px;
      `,
      title: 'Follow Friends’ lists',
      image: getCmsAsset(
        '4JmiD92WEMklDFYnF4wmZB/0f187e0c25571b232e7aa84e26b84a3e/travis-booklist.webp'
      ),
      altText: 'fable post by travis',
      position: { start: 400, end: -50 },
    },
  ],
  slides: {
    mobile: [
      {
        title: 'Good people sharing good stories',
        titleStyles: css`
          max-width: 200px;
          ${theme.mediaQueries.mobileL} {
            max-width: 310px;
          }
        `,
        image: getCmsAsset(
          '559BrSTegdnk4TJTnsxO8T/c879b67196829cb9e7c85332906c75ac/em-word-fable-post-mobile.webp'
        ),
        altText: 'fable post by em word',
      },
      {
        title: 'Follow friend’s lists',
        titleStyles: css`
          max-width: 140px;
          ${theme.mediaQueries.mobileL} {
            max-width: 230px;
          }
        `,
        image: getCmsAsset(
          '5Vb8HM2OGa95Yc8CxhkkF2/405d51985a38cf13ec7ab11b4cfd7d04/alex-posey-fable-watchlist.webp'
        ),
        altText: 'fable watchlists post by alex posey',
      },
      {
        title: 'Take fun mood quizes',
        titleStyles: css`
          max-width: 140px;
          ${theme.mediaQueries.mobileL} {
            max-width: 230px;
          }
        `,
        image: getCmsAsset(
          '7CU9lEJv0sEc39UqMZ4u5M/4686f2b4873f87d1096ace0bbe75c64e/mood-quiz-preview.webp'
        ),
        imageStyles: css`
          max-width: none;
          transform: scale(1.2);
        `,
        containerStyles: css`
          overflow: visible;
        `,
        altText: 'mood quiz preview',
      },
    ],
    desktop: {
      title: 'Good people sharing good stories',
      images: [
        {
          image: getCmsAsset(
            '2PY6cxhK7ZCubEHo7FdzyN/e4aab095da1539138de48269304b83e1/em-word-fable-post.webp',
            { width: 1800 }
          ),
          altText: 'fable post by em word',
        },
        {
          image: getCmsAsset(
            '7u6dWsoi5AAGqNO2CcgDoh/0e04efb44f1b48af13eadd3de577cccc/gracelynnkelly-fable-review-post.webp',
            { width: 1800 }
          ),
          altText: 'fable post by gracelynnkelly',
        },
        {
          image: getCmsAsset(
            '4gacvOCA7i0FBjNj1PCJzG/52fe37dffc348d7fdfcb5f74c767ca31/sonia-rai-fable-quote-post.webp',
            { width: 1800 }
          ),
          altText: 'fable post by sonia rai',
        },
      ],
    },
  },
}

const organize: HomeFeaturesProps = {
  id: 'organize',
  header: (
    <HomeFeaturesHeader
      label="Organize"
      title="Track your books and shows"
      description="Stay organized with lists, goals, stats, and more tools designed to keep you on top of all your books and shows."
    />
  ),
  illo: (
    <HomeFeaturesIllo
      className={css`
        margin-top: 20px;
        ${theme.mediaQueries.mobileL} {
          margin-top: 0;
        }
        z-index: 1;
      `}
      image={getCmsAsset(
        'UPGAWXPRbWGRvXSAV4X2z/902e729d0be6894922af1956ee564816/person-and-floating-shapes.png',
        { width: 1600 }
      )}
      altText="person and floating shapes"
    />
  ),
  scrollingCards: [
    {
      titleStyles: css`
        max-width: 200px;
      `,
      title: 'Make new healthy habits',
      image: getCmsAsset(
        '44xFCMmSRfZg8jCSCnQf6R/aff2177d77636f608ee5b5728e75987a/stats-preview.webp'
      ),
      altText: 'user stats preview',
    },
    {
      containerStyles: css`
        overflow: visible;
      `,
      titleStyles: css`
        max-width: 200px;
      `,
      title: 'Share your monthly progress',
      image: getCmsAsset(
        '6DYW3EupgmgibvH4wsTdrE/4cc33722492db89c0a933722e470a210/monthly-wrap-preview.webp'
      ),
      altText: 'monthly wrap preview',
    },
  ],
  slides: {
    mobile: [
      {
        title: 'Build better read and watch lists',
        titleStyles: css`
          max-width: 200px;
          ${theme.mediaQueries.mobileL} {
            max-width: 290px;
          }
        `,
        image: getCmsAsset(
          '3UzB2ClcQDrwVPPjzzLB7P/d47674a0f20d990719972dee3de1fb94/read-and-watch-lists-preview-mobile.webp'
        ),
        altText: 'read and watch lists preview',
      },
      {
        title: 'Create new healthy habits',
        titleStyles: css`
          max-width: 180px;
          ${theme.mediaQueries.mobileL} {
            max-width: 290px;
          }
        `,
        image: getCmsAsset(
          '69gbvE22zV6ITtC3ubM5G7/a08c7228e5b6296b70523cfb70c75c4c/stats-preview-tall.webp'
        ),
        altText: 'use stats preview',
      },
      {
        title: 'Share your monthly progress',
        titleStyles: css`
          max-width: 180px;
          ${theme.mediaQueries.mobileL} {
            max-width: 290px;
          }
        `,
        image: getCmsAsset(
          '09XeyNDOSXjz3soUVIlyf/df7f1abebef9c04b494e8a07f1e36260/monthly-wrap-preview-tall.webp'
        ),
        altText: 'monthly wrap preview',
      },
    ],
    desktop: {
      title: 'Build your read and watch lists',
      images: [
        {
          image: getCmsAsset(
            '3Owbk16bPp7z2vTCmvzPvq/be883df6af639bb716a130bb0fb270bc/watchlists-preview.webp',
            { width: 1800 }
          ),
          altText: 'tv watchlists preview',
        },
        {
          image: getCmsAsset(
            '4Ir9GBAv4c6mzZUJsIZ22c/aa8e4005752bb2eb310cf705ff4991ef/read-and-watch-lists-preview.webp',
            { width: 1800 }
          ),
          altText: 'read and watchlist preview',
        },
        {
          image: getCmsAsset(
            '2SOJ8DKhdGpPAVfC7B4frU/66cd03a81e1105b07dbc3259e8294743/wtr-shortlist-preview.webp',
            { width: 1800 }
          ),
          altText: 'want to read shortlist grid',
        },
      ],
    },
  },
}

export const homeFeaturesMap = [discuss, discover, organize]
